import { useSelector, shallowEqual } from 'react-redux';

const useGetPlanSections = () => {
    return useSelector(
      (state) => state?.AuthReducer?.userLogindata?.data?.plan?.sections,
      shallowEqual
    );
  };
  

export {useGetPlanSections};
